/**
 * Route for `global-goal-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GlobalGoalTrackingPage } from "../features/global-goal-tracking/GlobalGoalTrackingPage";

export const globalGoalTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/global-goal-tracking",
	component: GlobalGoalTrackingPage,
});

export default globalGoalTrackingRoute;
